import React, { FC, useMemo, useRef } from 'react';

import { MdLocationPin } from 'react-icons/md';

import { Flex, Text, Button, Heading, Center } from '@chakra-ui/react';

import {
  CreateWashHubModal,
  CreateWashHubModalRef,
} from 'components/modules/CreateWashHubModal';
import { UserPill } from 'components/core/UserPill';
import { DataTable } from 'components/modules/DataTable';
import { EditWashHubModal } from 'components/modules/EditWashHubModal';
import { washHub } from 'store';
import { Location } from 'types/washhub';
import { WashHubViewProps } from './WashHub.props';

import { buildWashHubColumns } from './washHubColumns';

const WashHubView: FC<WashHubViewProps> = (props) => {
  const { isLoading, locations } = props;
  const selectedWashHub = washHub.selectors.useSelectedWashHub();
  const washHubId = selectedWashHub?._id || '';
  const editWashHubModalRef = useRef<any>(null);
  const createWashHubModalRef = useRef<CreateWashHubModalRef>(null);

  const columns = useMemo(() => buildWashHubColumns(), []);

  return (
    <Flex flex={1} direction="column" color="#262626" overflow="auto">
      <Flex alignItems="baseline">
        <Heading flex={1} fontSize="24px">
          Wash Hub Management
        </Heading>
        <Flex>
          <Button
            isDisabled={washHubId === ''}
            mr={2}
            minW="200px"
            leftIcon={<MdLocationPin size="20px" />}
            onClick={() => {
              createWashHubModalRef?.current?.onOpen?.();
            }}>
            Create WashHub
          </Button>
          <UserPill />
        </Flex>
      </Flex>
      <CreateWashHubModal ref={createWashHubModalRef} />
      <EditWashHubModal ref={editWashHubModalRef} />
      <Flex h="50px" />
      <DataTable<Location>
        mt={6}
        minW="900px"
        data={locations}
        columns={columns}
        isLoading={isLoading}
        onRowClick={(item) => {
          editWashHubModalRef?.current?.onOpen?.(item);
        }}
        renderEmpty={() => (
          <Center p={8}>
            <Text fontSize="20px">No Wash hub available</Text>
          </Center>
        )}
      />
    </Flex>
  );
};

export default WashHubView;
